import { PublicClientApplication } from "@azure/msal-browser";

// Azure AD App Registration
export const CLIENT_ID = import.meta.env.VITE_AZURE_CLIENT_ID;
if (!CLIENT_ID) {
  throw new Error("VITE_AZURE_CLIENT_ID environment variable is required");
}

// Azure AD Tenant ID
export const TENANT_ID = import.meta.env.VITE_AZURE_TENANT_ID;
if (!TENANT_ID) {
  throw new Error("VITE_AZURE_TENANT_ID environment variable is required");
}

// Scopes for Microsoft Fabric GraphQL API
export const AUTH_SCOPE =
  "https://analysis.windows.net/powerbi/api/GraphQLApi.Execute.All";

// Scope for Power BI report embedding
export const POWERBI_EMBED_SCOPE =
  "https://analysis.windows.net/powerbi/api/Report.Read.All";

// MSAL instance — singleton, created once at module level
export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
  },
});

// Power BI Report embedding configuration
export const POWERBI_REPORT_ID = import.meta.env.VITE_POWERBI_REPORT_ID || "";
export const POWERBI_WORKSPACE_ID =
  import.meta.env.VITE_POWERBI_WORKSPACE_ID || "";

// GraphQL endpoint
export const GRAPHQL_ENDPOINT = import.meta.env.VITE_GRAPHQL_ENDPOINT;
if (!GRAPHQL_ENDPOINT) {
  throw new Error("VITE_GRAPHQL_ENDPOINT environment variable is required");
}
